/**
 * Customer Insights opens as a popover, so every open remounts all of its queries.
 * Refetching unconditionally makes a reopen pay the full request waterfall again.
 * A short staleness window keeps the data fresh for practical purposes while a
 * reopen within the window renders straight from cache.
 *
 * Use this only for data the user does not change from the surrounding screens -
 * the customer record, the message list, an invoice detail. Grid-backed records use
 * CUSTOMER_INSIGHTS_REFRESH_VOLATILE_OPTIONS, because no mutation invalidates them
 * and a window there would show pre-change data after the user created a record.
 */
const CUSTOMER_INSIGHTS_STALE_AFTER_SECONDS = 30;

export const CUSTOMER_INSIGHTS_REFRESH_ON_REOPEN_OPTIONS = {
  refetchOnMountOrArgChange: CUSTOMER_INSIGHTS_STALE_AFTER_SECONDS,
} as const;
